import { useStoreon } from 'storeon/react';
import { useEffect } from 'react';
import { autoshowLoyaltyRegistrationModal } from 'common/utils/autoshow-loyalty-registration-modal';
import { REGISTRATION_MODAL } from 'actions';
import { State } from '../../../store/types';
import { getCustomerId } from 'selectors';

export const useAutoShowLoyaltyRegistrationModal = () => {
  const {
    dispatch,
    loyalty: { loyaltyAccountIdentifier, fetchLoyaltyAccount },
    cookies,
  } = useStoreon<State>('loyalty', 'cookies');
  const customerId = getCustomerId(cookies);

  useEffect(() => {
    const fetched = fetchLoyaltyAccount.fetched && !fetchLoyaltyAccount.error;

    if (!loyaltyAccountIdentifier && fetched) {
      const { needShow } = autoshowLoyaltyRegistrationModal(customerId);

      if (needShow) {
        dispatch(REGISTRATION_MODAL.open);
      }
    }
  }, [
    dispatch,
    loyaltyAccountIdentifier,
    fetchLoyaltyAccount.fetched,
    fetchLoyaltyAccount.error,
    customerId,
  ]);
};
